import { PROGRESS_ITEMS } from "@app/analytics/GettingStarted/model";

import { ProgressItemEnum, ProgressItem } from "./types";

export const isProgressItemCompleted = (
  progress: number,
  item: ProgressItemEnum
) => {
  return (progress & item) === item;
};

export const getProgressItemsFromProgress = (
  progress: number
): ProgressItem[] => {
  return PROGRESS_ITEMS.map((item) => ({
    ...item,
    completed: isProgressItemCompleted(progress, item.type),
  }));
};
